import { render } from "./VueCountryIntl.vue?vue&type=template&id=a2922f58&scoped=true"
import script from "./VueCountryIntl.vue?vue&type=script&lang=js"
export * from "./VueCountryIntl.vue?vue&type=script&lang=js"

import "./VueCountryIntl.vue?vue&type=style&index=0&id=a2922f58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2922f58"]])

export default __exports__